import { DSButtonV2 } from '@elliemae/ds-button';
import { memo } from 'react';
import { APPLY_EXCEPTION_LABEL } from '../utils/constants';

interface ApplyExceptionButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const ApplyExceptionButtonComponent = ({
  onClick,
  disabled = false,
}: ApplyExceptionButtonProps) => (
  <DSButtonV2
    buttonType="outline"
    size="s"
    disabled={disabled}
    onClick={onClick}
    data-testid="apply-exception-button"
  >
    {APPLY_EXCEPTION_LABEL}
  </DSButtonV2>
);

export const ApplyExceptionButton = memo(ApplyExceptionButtonComponent);
